import { CSSObject } from '@chakra-ui/react';

export const Wrapper: CSSObject = {
  display: ['none', null, 'flex'],
  justifyContent: 'center',
  mt: '72',
};
export const TextItem: CSSObject = {
  display: 'none',
};
